import {useI18n} from '@yandex-delivery/core/i18n'

export const useSegments = () => {
  const i18n = useI18n()

  return {
    [i18n('bdui.segment.options.auto_products', 'Автотовары')]: 'auto_products',
    [i18n('bdui.segment.options.ready_meals_and_cooking', 'Готовые блюда и кулинария')]: 'ready_meals_and_cooking',
    [i18n('bdui.segment.options.children_goods', 'Детские товары')]: 'children_goods',
    [i18n('bdui.segment.options.documents', 'Документы')]: 'documents',
    [i18n('bdui.segment.options.cosmetics_and_perfumes', 'Косметика и парфюмерия')]: 'cosmetics_and_perfumes',
    [i18n('bdui.segment.options.furniture', 'Мебель')]: 'furniture',
    [i18n('bdui.segment.options.medical_products', 'Медицинские товары')]: 'medical_products',
    [i18n('bdui.segment.options.clothing_and_accessories', 'Одежда и аксессуары')]: 'clothing_and_accessories',
    [i18n('bdui.segment.options.sporting_products', 'Спорттовары')]: 'sporting_products',
    [i18n('bdui.segment.options.construction_products', 'Строительные товары')]: 'construction_products',
    [i18n('bdui.segment.options.household_goods', 'Товары для дома')]: 'household_goods',
    [i18n('bdui.segment.options.leisure_and_hobby_products', 'Товары для досуга и хобби')]:
      'leisure_and_hobby_products',
    [i18n('bdui.segment.options.pet_supplies', 'Товары для животных')]: 'pet_supplies',
    [i18n('bdui.segment.options.goods_for_holidays', 'Товары для праздника')]: 'goods_for_holidays',
    [i18n(
      'bdui.segment.options.everyday_products',
      'Товары повседневного спроса (продукты питания, напитки, бытовая химия)',
    )]: 'everyday_products',
    [i18n('bdui.segment.options.flowers', 'Цветы')]: 'flowers',
    [i18n('bdui.segment.options.electronics_and_household_appliances', 'Электроника и бытовая техника')]:
      'electronics_and_household_appliances',
    [i18n('bdui.segment.options.other', 'Другие товары')]: 'other',
  } as const
}
